import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
import { setLoading } from "../loading/loadingSlice";

export const getNatCategory = createAsyncThunk("national_id/category", async (countryId, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const url = countryId ? `/api/v1/cc/national_id/category?country=${countryId}` : `/api/v1/cc/national_id/category`;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching identification list:", error);
    const errorMessage = error?.response?.data?.message || "Error identification patient list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

export const getPatientList = createAsyncThunk("profile/list", async ({ page, limit, search, status }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const params = {
      page,
      limit,
      sort: "-updatedAt",
      search,
      searchFields: "user.firstName,user.lastName,user.email,user.hnNumber",
      status,
    };
    const response = await api.get(`/api/v1/cc/profile/verification`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching patient list:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching patient list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const getRegisteredPatientList = createAsyncThunk("getRegisteredPatientList", async ({ page, limit, search, status }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const params = {
      page,
      limit,
      search,
      searchFields: "firstName,lastName,email,hnNumbe",
      status,
    };
    const response = await api.get(`/api/v1/cc/profile/unverified`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching patient list:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching patient list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const getVerifiedPfp = createAsyncThunk("getVerifiedPfp", async ({ page, limit, search }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const params = {
      page,
      limit,
      sort: "-userVerifiedOn",
      search,
      searchFields: "firstName,lastName,email,hnNumber",
    };
    const response = await api.get(`/api/v1/cc/profile/verified`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching patient list:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching patient list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const getSingleVPfp = createAsyncThunk("getSingleVPfp", async ({ userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));

    const response = await api.get(`/api/v1/cc/profile/verified/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching patient list:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching patient";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

export const editPatientProfile = createAsyncThunk("profile/editRequest", async ({ page, limit, search, status }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const params = {
      page,
      limit,
      sort: "-updatedAt",
      search,
      searchFields: "relative.firstName,relative.lastName,relative.email,relative.hnNumber",
      status,
    };
    const response = await api.get(`/api/v1/cc/profile/edit_request`, { params });
    return response.data;
  } catch (error) {
    console.error("Error updating patient details:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error updating patient details";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

export const getPersonalInfo = createAsyncThunk("profile/personalInfo", async ({ userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.get(`/api/v1/cc/profile/verification/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching personal info:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching patient list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// VERIFY PERSONAL INFO (STEP 1)
export const verifyPersonalInfo = createAsyncThunk("profile/verifyPersonalInfo", async ({ userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.put(`/api/v1/cc/profile/verification/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error verifying personal info:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error verifying patient list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// REJECT VERIFICATION AND EDIT REQUESTS
export const rejectRequest = createAsyncThunk("profile/rejectReq", async ({ userId, rejectionReason }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.patch(`/api/v1/cc/profile/verification/${userId}`, { rejectionReason });
    return response.data;
  } catch (error) {
    console.error("Error rejecting:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error while rejecting";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// GET ADDRESS OF REQUESTS
export const getCurrentAddress = createAsyncThunk("profile/getCurrentAddress", async ({ userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.get(`/api/v1/cc/profile/verification/${userId}/address`);
    return response.data;
  } catch (error) {
    console.error("Error getting address:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error while getting address";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// VERIFY AND UPDATE ADDRESS REQUEST
export const verifyAddress = createAsyncThunk("profile/verifyAddress", async ({ userId, updatedAdd }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.put(`/api/v1/cc/profile/verification/${userId}/address`, { ...updatedAdd });
    return response.data;
  } catch (error) {
    console.error("Error verifying address:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error verifying address";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
// VERIFY NATIONAL ID
export const verifyNationalId = createAsyncThunk("profile/verifyNationalId", async ({ userId, updatedId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.put(`/api/v1/cc/profile/verification/${userId}/national_id`, { ...updatedId });
    return response.data;
  } catch (error) {
    console.error("Error getting id:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error getting id";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
// GET NATIONAL ID
export const getNationalId = createAsyncThunk("profile/getNatId", async ({ userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.get(`/api/v1/cc/profile/verification/${userId}/national_id`);
    return response.data;
  } catch (error) {
    console.error("Error getting id:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error getting id";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// UPLOAD MEDIA
export const uploadMedia = createAsyncThunk("media/uploadMedia", async ({ files }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("files", file);
    });
    const response = await api.post("/api/v1/media/user/upload", formData);
    return response.data;
  } catch (error) {
    console.error("Error uploading media:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error uploading media";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// GET INSURANCE ID
export const getInsuranceId = createAsyncThunk("profile/getInsuranceId", async ({ userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.get(`/api/v1/cc/profile/verification/${userId}/insurance`);
    return response.data;
  } catch (error) {
    console.error("Error getting id:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error getting id";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// VERIFY INSURANCE ID
export const verifyInsuranceId = createAsyncThunk("profile/verifyInsuranceId", async ({ userId, updatedId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.put(`/api/v1/cc/profile/verification/${userId}/insurance`, { ...updatedId });
    return response.data;
  } catch (error) {
    console.error("Error verifying id:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error verifying id";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

//GENERATE HN NUMBER

export const verifyHnNumber = createAsyncThunk("profile/verifyHnNumber", async ({ userId, updatedInfo }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.post(`/api/v1/cc/profile/verification/${userId}`, { ...updatedInfo });
    return response.data;
  } catch (error) {
    console.error("Error verifying hn:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error verifying hn";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// REJECT  EDIT REQUESTS
export const rejectEditRequest = createAsyncThunk("profile/rejectEditRequest", async ({ userId, rejectionReason }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.patch(`/api/v1/cc/profile/edit_request/${userId}`, { rejectionReason });
    return response.data;
  } catch (error) {
    console.error("Error rejecting:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error while rejecting";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

export const getEditRequest = createAsyncThunk("profile/editRequestId", async ({ userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.get(`/api/v1/cc/profile/edit_request/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching personal info:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching patient list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

export const updateEditRequest = createAsyncThunk("profile/updateRequestId", async ({ userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.put(`/api/v1/cc/profile/edit_request/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching personal info:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching patient list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

export const verifyRelativeProfileRequest = createAsyncThunk("profile/verifyProfile", async ({ userId, data }, { dispatch }) => {
  try {
    console.log(data);
    console.log(userId);
    dispatch(setLoading(true));
    const response = await api.post(`/api/v1/cc/profile/edit_request/${userId}`, data);
    console.log(response.data);
    return response;
  } catch (error) {
    console.error("Error fetching personal info:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching patient list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
